import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NODE_20, NODE_21 } from '@app/@core/constants/common.constants';
import { PingService } from './ping.service';

@Component({
  selector: 'scf-ping',
  templateUrl: './ping.component.html',
  styleUrls: ['./ping.component.scss'],
})
export class PingComponent implements OnInit {
  isOK: boolean = false;
  load: boolean = false;
  node: string = '';
  htmlData: string = '';

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private pingService: PingService,
    private httpClient: HttpClient
  ) {}

  ngOnInit(): void {
    this.getNodeStatus();
  }

  private onError = (error: any) => {
    console.error('Ping:', error);
    this.isOK = false;
  };

  private getNodeStatus = () => {
    const currentUrl = window?.location?.href;
    const urlIp = currentUrl?.split('/');
    const domain = urlIp.length > 0 ? urlIp[2]?.split('.') : null;
    const nodeUrl = domain ? domain[domain.length - 1] : null;
    this.node = nodeUrl?.length === 2 ? nodeUrl : null;
    if (nodeUrl) {
      this.pingService
        .getCheckStatus(nodeUrl)
        .toPromise()
        .then(
          (data) => {
            console.log(data);
            if (data === true) {
              window.open('../globalcredit/assets/comprobacionPing_OK.html', '_self');
            } else {
              window.open('../globalcredit/assets/comprobacionPing_KO.html', '_self');
            }
          },
          (error) => this.onError(error)
        )
        .catch((error) => this.onError(error))
        .finally(() => (this.load = true));
    }
  };
}
